import styled from "styled-components";
import { theme } from '../../theme'

export const StyledSideBar = styled.nav`
background-color: ${theme.colors.mainWhite};
width: ${({ compact }) => (compact ? "70px" : "240px")};
height: 100vh;
position: sticky;
top: 0;
z-index: 1000;
box-shadow: 0px 5px 15px rgba(31, 44, 70, 0.08);
display: flex;
flex-direction: column;
transition-property: width, transform !important;
transition-duration: 0.3s !important;
transition-timing-function: cubic- bezier(0.4, 0, 1, 1) !important;
// overflow: hidden;

@media(max-width: 920px) {
    position: fixed;
    width: 240px;
    transform: translate3d(
        ${({ visible }) =>
        visible ? 0 : "calc(240px - 240px*2)"},
0,
    0
  );
transition: transform 0.3s
    ${({ visible }) =>
        visible
            ? "cubic-bezier(0.4, 0, 1, 1)"
            : "cubic-bezier(0, 0, 0.2, 1)"
    } !important;
}
@media(max-width: 356px) {
    height: 100%;
    // width: 100%;
}
`;